import { randomDate, randomName, randomWord } from '@rtls/map/util/factory/factory.util';
import * as Factory from 'factory.ts';
import { Stop } from './stop.model';

export const stopFactory = Factory.makeFactory<Stop>({
	deletedDate: Factory.each(() => new Date(randomDate())),
	extId: Factory.each(() => randomWord()),
	name: Factory.each(() => randomWord()),
	provider: Factory.each(() => randomName()),
	uuid: Factory.each(() => randomWord()),
});
